export const modalInitialState = {
	modalOpen: false,
	alertOpen: false,
	data: { firstName: "", lastName: "", id: "", date: new Date(), status: "Processed", approvedReason: undefined, type: "" },
};

export const modalActions = {
	MODAL_OPEN: "modal-open",
	MODAL_CLOSE: "modal-close",
	ALERT_OPEN: "alert-open",
	ALERT_CLOSE: "alert-close",
	SET_DATA: "set-data",
};

export const modalReducer = (state, action) => {
	switch (action.type) {
		case modalActions.SET_DATA:
			return { ...state, data: action.payload };
		case modalActions.MODAL_OPEN:
			return { ...state, modalOpen: true };
		case modalActions.MODAL_CLOSE:
			return { ...state, modalOpen: false };
		case modalActions.ALERT_OPEN:
			return { ...state, alertOpen: true };
		case modalActions.ALERT_CLOSE:
			return { ...state, alertOpen: false };
		default:
			throw new Error("Invalid Action at modalReducer ");
	}
};
